/**
 * 진입/학생 코드 입력 정규화.
 * 비영숫자(공백·특수문자)를 제거하고 대문자화한다. maxLength 가 주어지면 그 길이로 자른다.
 *
 * code-login(U-prefix 8자 고정)·/join(클래스·enterCode·U코드 혼합) 양쪽 입력칸이
 * 동일한 입력 위생을 갖도록 공유한다. 길이 정책만 호출측에서 다르게 준다
 * (code-login=8 고정, /join=enterCode 가 증가 시퀀스라 넉넉한 상한).
 */
export function normalizeEntryCode(value: string, maxLength?: number): string {
  const normalized = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  return maxLength != null ? normalized.slice(0, maxLength) : normalized;
}
